import { createFSMReducer } from 'app-webtech-core/reducers/fsm';
import { FETCH_ALL, RESET } from '../actions/types';
import {
  linearChannelFetchAllRequestReducer,
  linearChannelsFetchAllFailureReducer,
  linearChannelsFetchAllSuccessReducer,
} from './fetchAll';
import { linearChannelsResetReducer } from './reset';
import { LINEAR_CHANNELS_STATE_STATUSES } from '../constants';

export const defaultState = {
  params: {},
  result: [],
  slugs: [],
  categories: [],
  numbers: [],
  entities: {},
  status: LINEAR_CHANNELS_STATE_STATUSES.EMPTY,
  error: null,
};

const params = {
  initial: LINEAR_CHANNELS_STATE_STATUSES.EMPTY,
  actionReducers: {
    [FETCH_ALL.REQUEST]: {
      reducer: linearChannelFetchAllRequestReducer,
    },
    [FETCH_ALL.SUCCESS]: {
      reducer: linearChannelsFetchAllSuccessReducer,
      next: LINEAR_CHANNELS_STATE_STATUSES.DONE,
    },
    [FETCH_ALL.FAILURE]: {
      reducer: linearChannelsFetchAllFailureReducer,
      next: LINEAR_CHANNELS_STATE_STATUSES.ERROR,
    },
    [RESET]: linearChannelsResetReducer,
  },
  states: {
    [LINEAR_CHANNELS_STATE_STATUSES.EMPTY]: {
      accepts: [FETCH_ALL.REQUEST],
    },
    [LINEAR_CHANNELS_STATE_STATUSES.PENDING]: {
      accepts: [FETCH_ALL.REQUEST, FETCH_ALL.SUCCESS, FETCH_ALL.FAILURE, RESET],
    },
    [LINEAR_CHANNELS_STATE_STATUSES.DONE]: {
      accepts: [FETCH_ALL.REQUEST, RESET],
    },
    [LINEAR_CHANNELS_STATE_STATUSES.ERROR]: {
      accepts: [FETCH_ALL.REQUEST, RESET],
    },
  },
};

export const linearChannelsReducer = createFSMReducer(defaultState, params);
